import React, { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import noThumbnail from "../../assets/noThumbnail.png";
import { YESNO, NOTFOUNDPIC } from "../../Constants";
import playButton from "../../assets/playButton.png";

const LibraryItem = (props) => {
  const [image, setImage] = useState(noThumbnail);
  const { onSelect, record } = props;
  
  const { 
    mediaId, 
    type, 
    isPlaying, 
    isSelected, 
    rotate = 0, 
    red = 0, 
    green = 0, 
    blue = 0, 
    saturation = 0,
    crf = 0
  } = record;
  const [reload, setReload] = useState(1);
  
  const getThumbnail = useCallback(
    (mediaId) => {
      axios
        .get("/api/medium/thumbnail/media/" + mediaId)
        .then((res) => {
          if (res.data === "") {
            setImage(NOTFOUNDPIC);
            setTimeout(() => {
              setReload(reload + 1);
            }, 2000);
          } else {
            setImage(res.data);
          }
        })
        .catch((e) => {
          setImage(NOTFOUNDPIC);
          setTimeout(() => {
            setReload(reload + 1);
          }, 2000);
        });
    },
    [reload]
  );

  useEffect(() => {
    getThumbnail(mediaId);
  }, [mediaId, reload, getThumbnail]);
  
  const handleClick = (ev) => {
    onSelect && onSelect(record);
  };

//   const [imgDimensions, setImgDimensions] = useState({ width: 0, height: 0 });

// useEffect(() => {
//   const img = new window.Image();
//   img.onload = () => setImgDimensions({ width: img.width, height: img.height });
//   img.src = image;
// }, [image]);

//   const isLandscape = imgDimensions.width > imgDimensions.height;
  
  // Calculate CSS filters for thumbnail preview
  const redFilter = red > 0 ? red / 100 : 0;
  const greenFilter = green > 0 ? green / 100 : 0;
  const blueFilter = blue > 0 ? blue / 100 : 0;
  const saturationValue = saturation > 0 ? 1 + saturation / 100 : 1;
  const crfFilter = crf > 0 ? crf / 100 : 0;
  
  const imageStyle = {
    transform: `rotate(${rotate || 0}deg)`,
    filter: `
      saturate(${saturationValue})
      brightness(${1 + (redFilter + greenFilter + blueFilter) / 3})
    `,
    transition: 'all 0.2s ease-in-out',
    height: 'auto',
    width: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain'
  };
  
  const className = isSelected === YESNO.YES ? "mediaContainer isSelected" : "mediaContainer";
  
  return (
    <>
      <div className={className}>
        <img 
          style={imageStyle} 
          src={image} 
          alt="" 
          onClick={handleClick} 
        />

        {isPlaying === YESNO.YES && (
          <div className="playButton">
            <img height="24px" src={playButton} alt="isPlaying" />
          </div>
        )}
      </div>
    </>
  );
};

export default LibraryItem;